export function getAjax(request:any, timeout?: number) {
    request.type = "GET";
    return _doAjax(request, timeout);
}

export function postAjax(request: any, timeout?: number) {
    request.type = "POST";
    return _doAjax(request, timeout);
}

export function putAjax(request: any, timeout?: number) {
    request.type = "PUT";
    return _doAjax(request, timeout);
}

export function deleteAjax(request:any, timeout?: number) {
    request.type = "DELETE";
    return _doAjax(request, timeout);
}

function _doAjax(request:any, timeout: number) {
    const xhr = new XMLHttpRequest();
    // we have to clean the url that comes in order to make the same request for the same call
    let urlPart = request.url.split("://");
    let protocol = "";
    let urlTemp = "";
    // url base
    if (urlPart.length > 1) {
        protocol = urlPart[0] + "://";
        urlTemp = urlPart[1];
    } else {
        protocol = "";
        urlTemp = urlPart[0];
    }
    let url = "";
    let params = "";
    // work with url params
    urlPart = urlTemp.split("?");
    url = urlPart.shift();
    if (urlPart.length) {
        params = "?" + urlPart[0];
    }
    // don't add timestamp to ressources URL : http://(...).svg only relative API call : /api/component
    if(protocol === "") {
        params = ((params === "") ? "?" : params + "&") + "timestamp=" + new Date().valueOf();
    }
    url = url.split("//").join("/");
    request.url = protocol + url + params;
    xhr.open(request.type, request.url);
    xhr.timeout = timeout || 60000;
    xhr.ontimeout = function() 
    {
        if (request.error) {
            request.error("Timeout  on ajax call");
        }
    };
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3) {
            if (xhr.status==200) {
                if (request.success) {
                    request.success(xhr.responseText);
                }
            } else {
                if (request.error) {
                    request.error(xhr.responseText);
                }
            }
            if (request.finally) {
                request.finally(xhr.responseText);
            }
        }
    };
    request.headers = [];
    if(!request.cors) {
        if (request.data) {
            request.headers.push({"key" : "Content-Type", "value" : "application/json"});
        } else {
            request.headers.push({"key" : "Content-Type", "value" : "text/plain"});
        }
    }
    if (request.xmlHttpRequest) {
        request.headers.push({"key" : "X-Requested-With", "value" : "XMLHttpRequest"});
    }
    for (let i = 0; i < request.headers.length; i++) {
        xhr.setRequestHeader(request.headers[i].key, request.headers[i].value);
    }
    if (request.data) {
        if (!request.type) {
            request.type = "POST";
        }
        xhr.send(JSON.stringify(request.data));
    } else {
        if (!request.type) {
            request.type = "GET";
        }
        xhr.send();
    }
    return xhr;
}
